import { routesByPathname } from 'enums/routes'

const findRouteByPathname = (pathname: string) => {
  /**
   * if the exact pathname cannot be found then look for access attached to parent paths
   * for example - /styleguide/card might not have it's own route
   * but /styleguide might
   */
  const splitPathname = pathname.split('/')

  for (let index = 0; index < splitPathname.length; index++) {
    const parentPathname = splitPathname
      .slice(0, splitPathname.length - index)
      .join('/')

    if (!routesByPathname[parentPathname]) {
      continue
    }

    return routesByPathname[parentPathname]
  }
}

export default findRouteByPathname
